import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchBookingSources } from '@/renderer/services/accommodationService';

export function useBookingSources() {
  return useQuery({
    queryKey: queryKeys.accommodation.bookingSources(),
    queryFn: async () => {
      const data = await fetchBookingSources();
      return data;
    },
    staleTime: 1000 * 60 * 15, // 15 min — static lookup table
  });
}
